import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";

export function DuplicateDialog({ dup, onCancel, onConfirm, basePath, render }) {
  return (
    <AlertDialog open={!!dup} onOpenChange={(o) => !o && onCancel()}>
      <AlertDialogContent data-testid="duplicate-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>Possible duplicate</AlertDialogTitle>
          <AlertDialogDescription>{dup?.message}</AlertDialogDescription>
        </AlertDialogHeader>
        <div className="space-y-2">
          {dup?.duplicates?.map((d) => (
            <Link key={d.id} to={`${basePath}/${d.id}`} target="_blank" className="block rounded-lg border p-3 text-sm hover:bg-secondary" data-testid={`duplicate-item-${d.id}`}>
              {render(d)}
            </Link>
          ))}
        </div>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="duplicate-cancel-button">Go back</AlertDialogCancel>
          <AlertDialogAction data-testid="duplicate-save-anyway-button" onClick={onConfirm}>Save anyway</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}

export function ConfirmDialog({ open, onOpenChange, title, text, confirmLabel = "Delete", onConfirm, testid = "confirm-dialog" }) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent data-testid={testid}>
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription>{text}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid={`${testid}-cancel`}>Cancel</AlertDialogCancel>
          <Button variant="destructive" data-testid={`${testid}-confirm`} onClick={onConfirm}>{confirmLabel}</Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
